export const SIZE_LABEL = 2;
export const SIZE_TEXT = 10;
